/**
 * Centralized route path constants for all internal links.
 * Single source of truth for URL structure — update here when routes change.
 */

// ── Static pages ──
export const ROUTES = {
  home: "/",
  features: "/yacht-platform-features",
  modules: "/yacht-software-modules",
  charter: "/yacht-charter-management-software",
  management: "/yacht-management-software",
  sales: "/yacht-brokerage-software",
  services: "/yacht-management-services",
  demo: "/book-demo",
  privacy: "/privacy-policy",
  terms: "/terms-of-service",
  solutions: "/yacht-industry-solutions",
  whyUs: "/why-seaventis",
  about: "/about",
  contact: "/contact",
  careers: "/careers",
  press: "/press",
  news: "/yacht-industry-news",
  sitemap: "/sitemap",
} as const;

// ── Feature detail (slug unchanged, parent path updated) ──
export const featurePath = (slug: string) => `/yacht-platform-features/${slug}`;

// ── Solution detail slugs (old data key → new URL slug) ──
export const SOLUTION_SLUG_MAP: Record<string, string> = {
  "charter-brokers": "charter-broker-software",
  "yacht-brokers": "yacht-broker-software",
  "yacht-managers": "yacht-manager-software",
};

export const SOLUTION_SLUG_REVERSE: Record<string, string> = Object.fromEntries(
  Object.entries(SOLUTION_SLUG_MAP).map(([k, v]) => [v, k])
);

export const solutionPath = (dataSlug: string) =>
  `/yacht-industry-solutions/${SOLUTION_SLUG_MAP[dataSlug] || dataSlug}`;

// ── Why Us detail slugs (old data key → new URL slug) ──
export const WHY_US_SLUG_MAP: Record<string, string> = {
  "all-in-one": "all-in-one-yacht-platform",
  "built-for-professionals": "built-for-yacht-professionals",
  "security": "yacht-data-security",
  "mobile": "mobile-yacht-management",
};

export const WHY_US_SLUG_REVERSE: Record<string, string> = Object.fromEntries(
  Object.entries(WHY_US_SLUG_MAP).map(([k, v]) => [v, k])
);

export const whyUsPath = (dataSlug: string) =>
  `/why-seaventis/${WHY_US_SLUG_MAP[dataSlug] || dataSlug}`;

export const newsArticlePath = (slug: string) => `/yacht-industry-news/${slug}`;
